import { useEffect, useState } from "react";
import { Alert, Button, Stack, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import { getReminders } from "../../distflowAPI/plannerApi";

export default function PlannerReminders({ userId }) {
  const storageKey = `planner-reminders-snooze:${userId}`;
  const [items, setItems] = useState([]);
  const [snoozedUntil, setSnoozedUntil] = useState(() => {
    try {
      return Number(sessionStorage.getItem(storageKey)) || 0;
    } catch {
      return 0;
    }
  });
  const snooze = () => {
    const until = Date.now() + 3600000;
    setSnoozedUntil(until);
    try {
      sessionStorage.setItem(storageKey, String(until));
    } catch {
      /* Storage may be disabled. */
    }
  };
  useEffect(() => {
    let active = true;
    const refresh = () => {
      if (document.visibilityState === "hidden") return;
      getReminders()
        .then(({ data }) => {
          if (active) setItems(data);
        })
        .catch(() => {});
    };
    refresh();
    const timer = setInterval(refresh, 60000);
    window.addEventListener("planner-updated", refresh);
    document.addEventListener("visibilitychange", refresh);
    return () => {
      active = false;
      clearInterval(timer);
      window.removeEventListener("planner-updated", refresh);
      document.removeEventListener("visibilitychange", refresh);
    };
  }, []);
  if (!items.length || snoozedUntil > Date.now()) return null;
  return (
    <Alert
      severity="info"
      sx={{ mb: 2, "& .MuiAlert-message": { width: "100%", minWidth: 0 } }}
    >
      <Stack
        direction={{ xs: "column", sm: "row" }}
        spacing={1}
        justifyContent="space-between"
        alignItems={{ xs: "flex-start", sm: "center" }}
      >
        <Typography
          variant="body2"
          sx={{ overflowWrap: "anywhere", minWidth: 0 }}
        >
          {items.length === 1
            ? `Reminder: ${items[0].title}`
            : `${items.length} reminders due: ${items
                .slice(0, 2)
                .map((item) => item.title)
                .join(", ")}${items.length > 2 ? "…" : ""}`}
        </Typography>
        <Stack direction="row" sx={{ flexShrink: 0 }}>
          <Button
            component={Link}
            to="/my-checklist"
            color="inherit"
            size="small"
          >
            Open checklist
          </Button>
          <Button size="small" color="inherit" onClick={snooze}>
            Snooze 1h
          </Button>
        </Stack>
      </Stack>
    </Alert>
  );
}
